import { board_click, board_expose } from "./board";
import { button_click, button_expose } from "./buttonClick";
import { dialog_action, dialog_expose } from "./dialog";
import { content_expose } from "./expose";
import { material_click } from "./materialClick";
import { pay_expose } from "./pay";
import { people_click, people_expose } from "./people";
import { questionnaire_click, questionnaire_expose } from "./question";
import { resource_loc_click, resource_loc_expose } from "./resource";
import { switch_version } from "./switchVersion";
import { topic_click } from "./topicClick";
import { topic_expose } from "./topicExpose";

/**
 * 自动采集监听事件初始化
 * @param {*} trigger
 */
export default function collectInit(trigger) {
  trigger.on("content_expose", content_expose);
  trigger.on("material_click", material_click);
  trigger.on("button_click", button_click);
  trigger.on("button_expose", button_expose);
  trigger.on("switch_version", switch_version);
  trigger.on("topic_expose", topic_expose);
  trigger.on("topic_click", topic_click);
  trigger.on("board_expose", board_expose);
  trigger.on("board_click", board_click);
  // trigger.on("ad_click", ad_click);
  // trigger.on("ad_expose", ad_expose);
  trigger.on("dialog_expose", dialog_expose);
  trigger.on("dialog_action", dialog_action);
  trigger.on("people_expose", people_expose);
  trigger.on("people_click", people_click);
  trigger.on("resource_loc_expose", resource_loc_expose);
  trigger.on("resource_loc_click", resource_loc_click);
  trigger.on("pay_expose", pay_expose);

  trigger.on("questionnaire_expose", questionnaire_expose);
  trigger.on("questionnaire_click", questionnaire_click);
}
